var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('p',{staticClass:"loading",class:_vm.type},[_c('i',{staticClass:"fa fa-2x fa-spin fa-cog",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }